import { useTranslation } from "react-i18next";
import { IconGenstart, IconStjerne } from "../../components/icons";
import Results from "../results/Results";
import Step1Forbrug from "./Step1Forbrug";
import Step2Situation from "./Step2Situation";
import Step3Ude from "./Step3Ude";
import { useWizard } from "./WizardContext";

const stepKeys = ["steps.s1", "steps.s2", "steps.s3", "steps.s4"];

export default function Wizard() {
  const { t } = useTranslation();
  const { state, dispatch } = useWizard();
  const go = (n: 0 | 1 | 2 | 3) => {
    dispatch({ type: "step", value: n });
    document.getElementById("wizard")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="wizard" className="mb-20 mt-10 scroll-mt-24 overflow-hidden rounded-l border border-line bg-surface shadow-soft">
      {/* progress */}
      <div className="flex flex-wrap items-center gap-4 border-b border-line px-6 py-5">
        <div className="flex items-center gap-1.5 font-mono text-xs">
          {stepKeys.map((k, i) => (
            <div key={k} className="flex items-center gap-2.5">
              {i > 0 && <span className="h-px w-4 bg-line" />}
              <button
                type="button"
                onClick={() => go(i as 0 | 1 | 2 | 3)}
                aria-current={i === state.step ? "step" : undefined}
                aria-label={t("a11y.stepGoto", { step: t(k) })}
                className={`flex cursor-pointer items-center gap-2 rounded-full py-1 transition hover:text-ink ${
                  i === state.step ? "text-ink" : "text-ink-faint"
                }`}
              >
                <span
                  className={`grid h-[26px] w-[26px] place-items-center rounded-full border text-xs transition ${
                    i === state.step ? "border-ink bg-ink text-accent" : i < state.step ? "border-accent bg-accent text-accent-ink" : "border-line"
                  }`}
                >
                  {i < 3 ? i + 1 : <IconStjerne className="h-[13px] w-[13px]" />}
                </span>
                <span className="hidden sm:inline">{t(k)}</span>
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* stage */}
      <div className="px-6 py-9 sm:px-11">
        {state.step === 0 && <Step1Forbrug />}
        {state.step === 1 && <Step2Situation />}
        {state.step === 2 && <Step3Ude />}
        {state.step === 3 && <Results />}

        <div className="mt-8 flex items-center justify-between gap-4">
          {state.step > 0 && state.step < 3 ? (
            <button className="btn btn-ghost" onClick={() => go((state.step - 1) as 0 | 1 | 2)}>{t("nav2.back")}</button>
          ) : (
            <span />
          )}
          {state.step === 0 && <button className="btn btn-primary" onClick={() => go(1)}>{t("nav2.next")}</button>}
          {state.step === 1 && <button className="btn btn-primary" onClick={() => go(2)}>{t("nav2.next")}</button>}
          {state.step === 2 && <button className="btn btn-primary" onClick={() => go(3)}>{t("nav2.calc")}</button>}
          {state.step === 3 && (
            <button className="btn btn-ghost" onClick={() => go(0)}>
              <IconGenstart className="h-[17px] w-[17px]" />
              {t("nav2.restart")}
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
